import React, { useCallback } from 'react';

import { SignUpForm } from '~/features/auth/components/sign-up-form';
import { signIn } from '~/features/auth/store/actions.thunks';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useHeaderColorChanger } from '~/utils/hooks/useHeaderColorChanger';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import css from './styles.module.scss';
import { Box } from '@material-ui/core';
import ASlogo from '~/img/AS-logo.svg';
import logomark from '~/img/logomark.svg';

interface SignUpProps {}

export const SignUP: React.FC<SignUpProps> = () => {
    useHeaderColorChanger('white', 'var(--color-gray-primary)');

    const dispatch = useThunkDispatch();

    const route = useAppRoute();

    const signInAction = useCallback(
        async (...p: Parameters<typeof signIn>) => {
            const result = await dispatch(signIn(...p));

            if (result?.error) {
                return result;
            }

            route('/');
        },
        [dispatch, route]
    );

    return (
        <article className={css.module}>
            <SignUpForm action={signInAction} />
            <Box className={css.rightBox}>
                <img src={ASlogo} alt="ASlogo" className={css.logo} />
                <img src={logomark} alt="logomark" className={css.substrate} />
            </Box>
        </article>
    );
};
